var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8972 14.5849L7.90129 9.3344C7.27631 10.7491 6.97911 12.2884 7.03216 13.8358L9.61322 18.3239C9.68126 18.4403 9.77716 18.5377 9.89217 18.6072C10.0072 18.6766 10.1376 18.716 10.2716 18.7217H11.4766C11.6087 18.7181 11.738 18.6818 11.8528 18.6159C11.9677 18.5499 12.0646 18.4565 12.135 18.3438L17.7712 8.49909C17.7916 8.47083 17.8063 8.43879 17.8143 8.4048C17.8224 8.37082 17.8237 8.33556 17.8182 8.30106C17.8127 8.26656 17.8005 8.2335 17.7823 8.20377C17.764 8.17404 17.7401 8.14824 17.7119 8.12784C17.6572 8.09241 17.5924 8.0761 17.5276 8.08143H15.0321C14.9316 8.08677 14.8336 8.11524 14.7457 8.16465C14.6578 8.21407 14.5824 8.28312 14.5251 8.3665L10.8972 14.5849Z",
    fill: "#20323F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6828 0C16.7964 10.2756 6.13642 0 6.13642 12.2446L0.157851 1.89602C0.0503625 1.70857 -0.00622559 1.49593 -0.00622559 1.27948C-0.00622559 1.06303 0.0503625 0.850396 0.157851 0.662945C0.257685 0.469804 0.406532 0.306722 0.589259 0.19028C0.771986 0.0738371 0.982078 0.00818571 1.19817 0L22.6828 0Z",
    fill: "#E72076"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.92d31d2a56aee21d5ec1f481d590cba3.svg";
export { ForwardRef as ReactComponent };